import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './component/Login/Login';
import { Dashboard } from './component/Dashboard/Dashboard';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { Judge } from './component/Dashboard/adminmenus/Judge';
import { Event } from './component/Dashboard/adminmenus/Event';
import { Vote } from './component/Dashboard/judgemenus/Vote';
import { Participants } from './component/Dashboard/adminmenus/Participants';
import { Voting } from './component/Dashboard/adminmenus/Voting';
import { Games } from './component/Dashboard/adminmenus/Games';
import { NotFound } from './component/NotFound/NotFound';

axios.defaults.baseURL = "https://endpoint.e-dats.info" //uncomment for production
// axios.defaults.baseURL = "http://localhost/denr-endpoints" //uncomment for development
// axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/hris-back-end/public'
// axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/hris-back-end-mobile/public'
// axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/hris-back-end_develop/public'
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json'

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('queue_token')
  config.headers.Authorization = token ? `Bearer ${token}` : ''
  
  return config
})

function App() {
  const user = localStorage.getItem('user')
  const userType = localStorage.getItem('user_type');
  const showDashboard = () =>{
    if(user){
      switch(JSON.parse(user).role){
        case 1:
          return(
          <>
              <Route index element={<Voting name={user} />}/>
              <Route path='/dashboard/judges' element={<Judge/>}/>
              <Route path='/dashboard/participants' element={<Participants/>}/>
              <Route path='/dashboard/voting' element={<Voting/>}/>
              <Route path='/dashboard/games' element={<Games/>}/>
          </>)
          break;
        case 0:
          return(
          <>
              <Route index element={<Vote name={user} />} />
              <Route path='/dashboard/vote' element={<Vote/>} />
          </>)
          break;
      }
    }
  }
  return (
    <>
    <BrowserRouter>
        <Routes>
          <Route path='/' element={<LoginPage/>} />
          {/* <Route path='/dashboard' element={<Dashboard/>} /> */}
          <Route path={`/dashboard`} element={<Dashboard/>}>
              {showDashboard()}
              <Route path='*' exact={true} element={<NotFound/>} />

              {/* <Route index element={<Judge name={user} />} />
              <Route path='/dashboard/judge' element={<Judge/>} />
              <Route path='/dashboard/event' element={<Event/>} /> */}
          </Route>
        </Routes>
    </BrowserRouter>
    <Toaster/>
    </>
  );
}

export default App;
function ProtectedRoute({ user, children }) {
  if (!user) {
    return <Navigate to={`/`} replace />;
  }
  return children;
};
function IsLogin({ user, userType, children }) {
  if (user) {
    if(userType === 0){
      return <Navigate to={`/dashboard`} replace />;
    }else{
      return <Navigate to={`/admin`} replace />;
    }
  }
  return children;
};
